
/**
 * Structure for transfer of search prameters via url
 */
export class HisSearch {

    configFile: string;
    resultConfigFile?: string;
    allResultConfigFiles?: string[] = [];
    groups: HisSearchGroup[] = [];
}

export class HisSearchGroup {

    groupLabel: string;
    criteria: HisSearchCriteria[] = [];
    criteriaGroupAnd: boolean;
    criteriaGroups: HisSearchCriteriaGroup[] = [];
}

export class HisSearchCriteria {

    // pfad oder label
    field: string;
    not: boolean;
    operator: HisSearchCriteriaOperator;
    value: string;
}

export class HisSearchCriteriaGroup {

    excluding: boolean;
    criteria: HisSearchCriteria[] = [];
}

export enum HisSearchCriteriaOperator {
    // currently not used
    EQ = '=',
    NE = '<>',
    LT = '<',
    GT = '>'

}
